import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import DataProtectionPolicyContainer from '../../components/Consent/components/DataProtectionPolicyContainer';

const Container = styled.div`
  padding: 32px 24px;
`;
const TitleDataConsent = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: flex-start;
  letter-spacing: 0.25px;
  color: #06a3b4;
  margin-bottom: 16px;
`;
const IconBackArrow = styled.img`
  margin-right: 8px;
`;

export default function ProfileDataProtectionPolicy() {
  const router = useHistory();
  const handleBack = () => {
    router.goBack();
  };
  return (
    <Container>
      <TitleDataConsent>
        <IconBackArrow
          onClick={() => handleBack()}
          src="/icons/arrow-left-b.svg"
        />
        นโยบายคุ้มครองข้อมูลส่วนบุคคล (Data Protection Policy) <br /> LINE
        Official Account O2Lung
      </TitleDataConsent>
      <DataProtectionPolicyContainer />
    </Container>
  );
}
